const foodrecipes = {
    add: 'foodrecipes/add-by-admin',
    getlist: 'foodrecipes/getlist-by-admin',
    update: 'foodrecipes/update-by-admin',
    remove: 'foodrecipes/remove',
    get: 'foodrecipes/get-by-Admin',
    getall: 'foodrecipes/getall',
}
export default foodrecipes
